import axios from 'axios';
import ApiGet from '../../../sections/mainheader/apiget';


class LoyaltySetOpeningPointService {
    constructor(apiUrl) {
        this.GetApiUrl = apiUrl; 
        this.GetCreateLoyaltyOpeningPointCalControls = () => (axios.get(`${this.GetApiUrl}Loyalty/GetCreateLoyaltyOpeningPointCalControls`));
        this.SetLoyaltyOpening = (payload) => (axios.post(`${this.GetApiUrl}Loyalty/SetLoyaltyOpening`, payload));
        
    }
}


export default ApiGet().then((apiUrl) => new LoyaltySetOpeningPointService(apiUrl));